import { createSlice, createAction } from "@reduxjs/toolkit"; //Imports functions from Redux Toolkit for creating slices and actions.
import { OPERATION_HOME } from "../types/types";
// import TempTableData from '../../temp/24hoursData/table'
// import TempCardData from '../../temp/24hoursData/card'
import details from "../../temp/detailsData";
const operationHomeInitialState = {
  table: {
    data: [],
    filteredData: [],
    navigatorContext: [],   // overrides filteredData for InsightNavigator when set
    currentPage: 1,
    pageSize: 50,
    totalDataCount: 0,
  },
  cards: {
    stats: {
      calls: "",
      duration: {
        hour: "",
        minute: "",
        second: "",
      },
      open: "",
      closed: "",
      in_progress: "",
      VMopen: "",
      VMinProgress: "",
      VMclosed: "",
      OpenStatus: { high: 0, medium: 0, low: 0 },
      InProgressStatus: { high: 0, medium: 0, low: 0 },
      ClosedStatus: { high: 0, medium: 0, low: 0 },
      VMOpenStatus: { high: 0, medium: 0, low: 0 },
      VMInProgressStatus: { high: 0, medium: 0, low: 0 },
      VMClosedStatus: { high: 0, medium: 0, low: 0 },
    },
    selected: null,
  },
  details: {
    data: details[0],
  },
  sortFields: {},
  searchFields: {},
  activeTab: "last24Hours",
  activeSearch: null,
  activeSeverity: null,
  tabStartDate: null,
  tabEndDate: null,
  loading: false,
  requestProcessed: false,
  requestError: false,
  mnScoresByCallId: {},

  workScreenData: [],
  isWorkScreenLoading: false,

  //  performanceData:{
  //   customerSatisfaction: [
  //     { month: 'Jan', optimal: 7.5, actual: 7.2 },
  //     { month: 'Feb', optimal: 7.8, actual: 8.5 },
  //     { month: 'Mar', optimal: 7.6, actual: 7.0 },
  //     { month: 'Apr', optimal: 7.9, actual: 8.2 },
  //     { month: 'May', optimal: 7.7, actual: 6.8 },
  //     { month: 'Jun', optimal: 8.0, actual: 7.5 }
  //   ],
  //   firstCallResolution: [
  //     { month: 'Jan', value: 82 },
  //     { month: 'Feb', value: 85 },
  //     { month: 'Mar', value: 89 },
  //     { month: 'Apr', value: 84 },
  //     { month: 'May', value: 86 },
  //     { month: 'Jun', value: 83 }
  //   ],
  //   callsOnHold: [
  //     { month: 'Jan', value: 22 },
  //     { month: 'Feb', value: 29 },
  //     { month: 'Mar', value: 24 },
  //     { month: 'Apr', value: 27 },
  //     { month: 'May', value: 23 },
  //     { month: 'Jun', value: 25 }
  //   ],
  //   learningResources:[
  //     {
  //       id: '01',
  //       title: 'Active Listening for Improved Customer Interactions',
  //       link: '#'
  //     },
  //     {
  //       id: '02',
  //       title: 'Utilizing the Knowledge Base for Efficient Problem Resolution',
  //       link: '#'
  //     },
  //     {
  //       id: '03',
  //       title: 'De-Escalation Techniques for Managing Upset Customers',
  //       link: '#'
  //     }
  //   ],
  //   strengthMessage: "Your commitment to delivering outstanding customer service shines through every interaction. Last month, your ability to listen and resolve issues effectively contributed to a 95% customer satisfaction rate. Keep up the fantastic work, as your strengths continue to pave the way for excellence.",
  //   inspirationalQuote: "Each call you take is an opportunity to shine. Your strengths continue to guide you toward excellence."

  // },
  // performanceData: {
  //   customerSatisfaction: [],
  //   firstCallResolution: [],
  //   callsOnHold: [],
  //   learningResources: [],
  //   strengthMessage: "",
  //   inspirationalQuote: ""
  // },
};

// export const homeInit = createAction('homeInit') // Creates an action creator for initializing home data.
export const getOperationDataInit = createAction("getOperationDataInit"); // Creates an action creator for initializing operation data.
export const getOperationFilteredDataInit = createAction(
  "getOperationFilteredDataInit",
);
export const fetchFilteredTableDataInit = createAction(
  "fetchFilteredTableDataInit",
);
export const getDetailsPageDataInit = createAction("getDetailsPageDataInit");
export const fetchWorkScreenData = createAction("fetchWorkScreenData");
export const postWorkScreenData = createAction("postWorkScreenData");
// export const fetchPerformanceDataInit = createAction("fetchPerformanceDataInit");

export const operationHomeSlice = createSlice({
  name: OPERATION_HOME,
  initialState: operationHomeInitialState,
  reducers: {
    // homeInitSuccess(state, action) {
    //     state.loading = false;
    //     state.requestProcessed = true;
    //     state.requestError = false;
    //     state.table.data = action.payload?.tableData || state.table.data;
    //     // console.log(action.payload.tableData);
    //     state.table.currentPage = Number(action.payload?.currentPage) || 1
    //     state.table.pageSize = Number(action.payload?.pageSize) || 7
    //     state.table.totalDataCount = Number(action.payload?.totalDataCount) || state.table.data.length
    //     state.cards.stats = action.payload?.cardData || state.cards.stats;
    //     state.table.filteredData = action.payload?.tableData || state.table.filteredData
    // },
    // homeInitFailure(state) {
    //     state.loading = false;
    //     state.requestProcessed = true;
    //     state.requestError = true;
    // },
    getOperationDataSuccess(state, action) {
      // console.log("getState",action.payload)
      state.loading = false;
      state.requestProcessed = true;
      state.requestError = false;
      state.table.data = action.payload?.tableData || state.table.data;
      state.table.currentPage = Number(action.payload?.current_page) || 1;
      state.table.pageSize = Number(action.payload?.limit) || 20;
      state.table.totalDataCount =
        Number(action.payload?.totalDataCount) || state.table.data.length;
      state.cards.stats = action.payload?.cardData || state.cards.stats;
      state.table.filteredData =
        action.payload?.tableData || state.table.filteredData;
      state.table.navigatorContext = [];   // user returned to Ops Home, clear popup context
      state.cards.stats.VMopen =
        action.payload?.VMopen ?? state.cards.stats.VMopen;
      state.cards.stats.VMinProgress =
        action.payload?.VMinProgress ?? state.cards.stats.VMinProgress;
      state.cards.stats.VMclosed =
        action.payload?.VMclosed ?? state.cards.stats.VMclosed;
      state.cards.stats.OpenStatus =
        action.payload?.OpenStatus ?? state.cards.stats.OpenStatus;
      state.cards.stats.InProgressStatus =
        action.payload?.InProgressStatus ?? state.cards.stats.InProgressStatus;
      state.cards.stats.ClosedStatus =
        action.payload?.ClosedStatus ?? state.cards.stats.ClosedStatus;
      state.cards.stats.VMOpenStatus =
        action.payload?.VMOpenStatus ?? state.cards.stats.VMOpenStatus;
      state.cards.stats.VMInProgressStatus =
        action.payload?.VMInProgressStatus ??
        state.cards.stats.VMInProgressStatus;
      state.cards.stats.VMClosedStatus =
        action.payload?.VMClosedStatus ?? state.cards.stats.VMClosedStatus;
    },

    getOperationFilteredDataSuccess(state, action) {
      state.loading = false;
      state.requestProcessed = true;
      state.requestError = false;
      state.table.filteredData = action.payload.data;
      state.table.navigatorContext = [];   // user returned to Ops Home, clear popup context
      state.table.currentPage = Number(action.payload?.current_page) ?? 1;
      state.table.pageSize = Number(action.payload?.page_limit) ?? 5;
      state.table.totalDataCount =
        Number(action.payload?.total_rows) ?? action.payload.data.length;
      state.cards.stats.calls =
        action.payload?.totalCalls ?? state.cards.stats.calls;
      state.cards.stats.open = action.payload?.open ?? state.cards.stats.open;
      state.cards.stats.closed =
        action.payload?.closed ?? state.cards.stats.closed;
      state.cards.stats.in_progress =
        action.payload?.inProgress ?? state.cards.stats.in_progress;
      state.cards.stats.duration =
        action.payload?.duration ?? state.cards.stats.duration;
      state.cards.stats.VMopen =
        action.payload?.VMopen ?? state.cards.stats.VMopen;
      state.cards.stats.VMinProgress =
        action.payload?.VMinProgress ?? state.cards.stats.VMinProgress;
      state.cards.stats.VMclosed =
        action.payload?.VMclosed ?? state.cards.stats.VMclosed;
      state.cards.stats.OpenStatus =
        action.payload?.OpenStatus ?? state.cards.stats.OpenStatus;
      state.cards.stats.InProgressStatus =
        action.payload?.InProgressStatus ?? state.cards.stats.InProgressStatus;
      state.cards.stats.ClosedStatus =
        action.payload?.ClosedStatus ?? state.cards.stats.ClosedStatus;
      state.cards.stats.VMOpenStatus =
        action.payload?.VMOpenStatus ?? state.cards.stats.VMOpenStatus;
      state.cards.stats.VMInProgressStatus =
        action.payload?.VMInProgressStatus ??
        state.cards.stats.VMInProgressStatus;
      state.cards.stats.VMClosedStatus =
        action.payload?.VMClosedStatus ?? state.cards.stats.VMClosedStatus;
    },
    getDetailsPageDataSuccess(state, action) {
      state.loading = false;
      state.requestProcessed = true;
      state.requestError = false;
      state.details.data = action.payload;
      state.details.size = action.payload.size;
    },
    getDetailsPageDataFailure(state, action) {
      state.loading = false;
      state.requestProcessed = true;
      state.requestError = true;
    },
    getOperationFilteredDataFailure(state, action) {
      state.loading = false;
      state.requestError = true;
      state.requestProcessed = true;
    },
    setStartDate(state, action) {
      state.tabStartDate = action.payload;
    },
    setEndDate(state, action) {
      state.tabEndDate = action.payload;
    },
    fetchFilteredTableDataSuccess(state, action) {
      // console.log("action.payload", action.payload);
      state.loading = false;
      state.requestProcessed = true;
      state.requestError = false;
      state.table.data = action.payload?.tableData ?? state.table.data;
      state.table.filteredData =
        action.payload?.tableData ?? state.table.filteredData;
      state.table.pageSize = Number(
        action.payload.pageSize ?? state.table.pageSize,
      );
      state.table.totalDataCount = Number(
        action.payload.totalDataCount ?? state.table.totalDataCount,
      );
      state.table.currentPage = Number(
        action.payload.currentPage ?? state.table.currentPage,
      );
      state.cards.stats.calls =
        action.payload?.totalCalls ?? state.cards.stats.calls;
      state.cards.stats.open = action.payload?.open ?? state.cards.stats.open;
      state.cards.stats.closed =
        action.payload?.closed ?? state.cards.stats.closed;
      state.cards.stats.in_progress =
        action.payload?.inProgress ?? state.cards.stats.in_progress;
      state.cards.stats.duration =
        action.payload?.duration ?? state.cards.stats.duration;
      state.cards.stats.VMopen =
        action.payload?.VMopen ?? state.cards.stats.VMopen;
      state.cards.stats.VMinProgress =
        action.payload?.VMinProgress ?? state.cards.stats.VMinProgress;
      state.cards.stats.VMclosed =
        action.payload?.VMclosed ?? state.cards.stats.VMclosed;
      state.cards.stats.OpenStatus =
        action.payload?.OpenStatus ?? state.cards.stats.OpenStatus;
      state.cards.stats.InProgressStatus =
        action.payload?.InProgressStatus ?? state.cards.stats.InProgressStatus;
      state.cards.stats.ClosedStatus =
        action.payload?.ClosedStatus ?? state.cards.stats.ClosedStatus;
      state.cards.stats.VMOpenStatus =
        action.payload?.VMOpenStatus ?? state.cards.stats.VMOpenStatus;
      state.cards.stats.VMInProgressStatus =
        action.payload?.VMInProgressStatus ??
        state.cards.stats.VMInProgressStatus;
      state.cards.stats.VMClosedStatus =
        action.payload?.VMClosedStatus ?? state.cards.stats.VMClosedStatus;
    },
    fetchFilteredTableDataFailure(state) {
      state.loading = false;
      state.requestProcessed = true;
      state.requestError = true;
    },
    setSelectedCard(state, action) {
      state.cards.selected = action.payload;
    },
    setSortFields(state, action) {
      state.sortFields = { ...action.payload };
    },
    setSearchFields(state, action) {
      state.searchFields = { ...action.payload };
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setActiveTab(state, action) {
      state.activeTab = action.payload ?? "last24Hours";
    },
    setRequestStart(state, action) {
      state.loading = true;
      state.requestProcessed = false;
      state.requestError = false;
    },
    getOperationDataFailure(state) {
      state.loading = false;
      state.requestProcessed = true;
      state.requestError = true;
    },
    setFilteredData(state, action) {
      state.table.filteredData = action.payload;
      state.table.currentPage = 1;
    },
    setCurrentPage(state, action) {
      state.table.currentPage = Number(action.payload);
    },
    setPageSize(state, action) {
      state.table.pageSize = Number(action.payload);
      state.table.currentPage = 1;
    },
    resetState(state) {
      state.table.filteredData = state.table.data;
      state.table.currentPage = 1;
      state.table.pageSize = 20;
    },
    setIsWorkScreenLoading(state, action) {
      state.isWorkScreenLoading = action.payload;
    },
    getWorkScreenDataSuccess(state, action) {
      state.isWorkScreenLoading = false;
      state.requestProcessed = true;
      state.requestError = false;
      state.workScreenData = action.payload;
    },
    getWorkScreenDataFailure(state, action) {
      state.isWorkScreenLoading = false;
      state.requestProcessed = true;
      state.requestError = true;
    },
    // fetchWorkScreenData(state){
    //   state.isWorkScreenLoading=true;
    // }
    getMemberId(state, action) {
      state.memberId = action.payload;
    },
    postWorkScreenDataSuccess(state, action) {
      state.loading = false;
      state.isWorkScreenLoading = false;
      state.requestProcessed = true;
      state.requestError = false;
    },
    setActiveSearch(state, action) {
      state.activeSearch = action.payload;
      console.log("activeSearch", action, "activeSearch", state);

      state.activeSeverity =
        action.payload === "advance" ? state.activeSeverity : "";
    },
    setSeverityFilter(state, action) {
      state.activeSeverity = action.payload;
    },
    setActiveSort(state, action) {
      state.activeSort = action.payload;
    },
    setMNScore(state, action) {
      const { callId, score } = action.payload || {};
      if (!callId) return;
      state.mnScoresByCallId[callId] = score;
    },
    setNavigatorContext(state, action) {
      state.table.navigatorContext = action.payload ?? [];
    },
    resetDetailsData(state, action) {
      state.details.data = details[0];
      // navigatorContext intentionally NOT cleared here — it must survive
      // arrow navigation (which unmounts/remounts DetailsScreen). It is
      // cleared when Ops Home reloads fresh data (see getOperationDataSuccess
      // and getOperationFilteredDataSuccess below).
    },
    // performanceDataInit(state) {
    //   state.loading = true;
    //   state.requestProcessed = false;
    //   state.requestError = false;
    // },
    // fetchPerformanceDataSuccess(state, action) {
    //   state.loading = false;
    //   state.requestProcessed = true;
    //   state.requestError = false;
    //   state.performanceData = action.payload; // Update performance data here
    // },
    // fetchPerformanceDataFailure(state) {
    //   state.loading = false;
    //   state.requestProcessed = true;
    //   state.requestError = true;
    // },

    updateFeedbackStatus(state, action) {
      const { memberId, callId } = action.payload;

      const matchRow = (item) =>
        item.memberId === memberId && item.callId === callId;

      // update main table
      state.table.data.forEach((item) => {
        if (matchRow(item)) {
          item.FeedbackStatus = true;
        }
      });

      // update filtered table
      state.table.filteredData.forEach((item) => {
        if (matchRow(item)) {
          item.FeedbackStatus = true;
        }
      });
    },
  },
});

export const {
  setFilteredData,
  setCurrentPage,
  setPageSize,
  resetState,
  setRequestStart,
  resetDetailsData,
  // homeInitSuccess,
  // homeInitFailure,
  getOperationDataSuccess,
  getOperationDataFailure,
  fetchFilteredTableDataSuccess,
  fetchFilteredTableDataFailure,
  setLoading,
  setActiveTab,
  getOperationFilteredDataFailure,
  getOperationFilteredDataSuccess,
  setEndDate,
  setStartDate,
  getDetailsPageDataFailure,
  getDetailsPageDataSuccess,
  setSearchFields,
  setSortFields,
  setSelectedCard,
  setIsWorkScreenLoading,
  getWorkScreenDataSuccess,
  getWorkScreenDataFailure,
  getMemberId,
  postWorkScreenDataSuccess,
  setActiveSearch,
  setSeverityFilter,
  performanceDataInit,
  fetchPerformanceDataSuccess,
  fetchPerformanceDataFailure,
  setActiveSort,
  setMNScore,
  updateFeedbackStatus,
  setNavigatorContext,
} = operationHomeSlice.actions;

export default operationHomeSlice.reducer; // Exports the reducer to be used in the store.
